<template>
  <div v-loading="loading" element-loading-text="拼命加载中" class="main-frame">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="12">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                content="编辑评分标准"
              ></el-page-header>
            </el-col>

            <el-col style="text-align: right" :span="12">
              <el-button @click="save_model_info" type="primary"
                >保存</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <p style="color: red; text-align: center">
          * 营业额权重,SMOK营业额权重,shop-mall加分项三者之和为1
        </p>
        <el-form
          ref="form"
          class="edit_module"
          :inline="true"
          :model="pre_model_item"
        >
          <!-- <el-form-item label="门店地点：">
            <div class="block">
              <el-cascader
                v-model="form.country"
                :options="country_options"
                :props="props"
                collapse-tags
                @change="handleChange"
                clearable
              ></el-cascader>
            </div>
          </el-form-item> -->

          <!-- <el-form-item label="门店名称：">
            <el-input
              v-model="pre_model_item.company_name"
              placeholder="请输入门店名称"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="门店邮箱：">
            <el-input v-model="form.zip" placeholder="请输入邮箱"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="是否shopmall">
            <el-radio-group
              v-model="pre_model_item.is_shop_mall"
              @change="shop_mall_handle"
            >
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
               <el-radio v-model="form.is_shop_mall" :label="0">/</el-radio> -->
          <!-- </el-radio-group>
          </el-form-item> -->

          <!-- <el-form-item label="是否黄金商业区">
            <el-radio-group
              v-model="pre_model_item.is_golden_business_zone"
              @change="golden_business_handle"
            > -->
          <!-- <el-radio :label="true">是</el-radio> -->
          <!-- <el-radio :label="false">否</el-radio> -->
          <!-- <el-radio v-model="form.is_golden_business_zone" label="0"
                >/</el-radio -->
          <!-- > -->
          <!-- </el-radio-group> -->
          <!-- </el-form-item> -->
          <!-- <el-form-item>
            <el-switch
              v-model="form.newest"
              @change="switch_new_old"
              active-text="最新"
              inactive-text="最旧"
            >
            </el-switch>
          </el-form-item> -->
          <!-- <el-form-item label="门店地址：">
            <el-input
              v-model="form.address"
              placeholder="请输入门店地址"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="面积权重：">
            <el-input-number
              v-model="pre_model_item.area_score_weight"
              :step="0.1"
              :min="0"
              :max="1"
              label="面积权重"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="营业额权重：">
            <el-input-number
              v-model="pre_model_item.turnover_score_weight"
              :step="0.1"
              :min="0"
              :max="1"
              label="营业额权重"
            ></el-input-number>
          </el-form-item>
          <!-- <el-form-item label="门店面积">
            <el-input
              v-model="form.size"
              placeholder="请输入门店面积"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="smok营业额权重：">
            <el-input-number
              v-model="pre_model_item.smok_turnover_score_weight"
              :step="0.1"
              :min="0"
              :max="1"
              label="smok营业额权重"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="	shop mall 额外加分值：">
            <el-input v-model="pre_model_item.extra_shop_mall_score"></el-input>
          </el-form-item>
          <el-form-item label="	黄金商业区加分值：">
            <el-input
              v-model="pre_model_item.extra_golden_business_zone_score"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "AddStoreInfo",
  data() {
    return {
      loading: false,
      // props: { multiple: true },
      //   form: {
      //     area_score_weight: "",
      //     turnover_score_weight: "",
      //     smok_turnover_score_weight: "",
      //     extra_shop_mall_score: "",
      //     extra_golden_business_zone_score: "",
      //   },

      pre_model_item: {},
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    // handleChange(value) {
    //   this.form.country = value;
    //   if (value[0]) {
    //     this.form.country_id = value[0];
    //   }
    //   if (value[1]) {
    //     this.form.province_id = value[1];
    //   }
    //   if (value[2]) {
    //     this.form.city_id = value[2];
    //   }
    // },
    // 获取国家id
    get_country_info(e) {
      this.form.country_id = e;
    },
    // 获取国家列表
    get_country_list() {
      //   this.form.country_list = this.$common.get_address_list_info();
    },
    // 改变是否shop_mall状态单选框
    shop_mall_handle(value) {
      this.form.is_shop_mall = value;
    },
    // 改变是否黄金商业区单选框
    golden_business_handle(value) {
      this.form.is_golden_business_zone = value;
    },
    // async get_address() {
    //   let _me = this;
    //   _me.country_options = JSON.parse(sessionStorage .getItem("address_info"));

    //   // if (res.code == 1000000) {
    //   if (
    //     _me.country_options &&
    //     _me.country_options != undefined &&
    //     _me.country_options.length > 0
    //   ) {
    //     // console.log(data);
    //     let country_array = [];
    //     _me.country_options.forEach((first_item) => {
    //       let first_obj = {
    //         value: first_item.id,
    //         label: first_item.name,
    //         //   children: [
    //       };

    //       //   一级目录的children
    //       if (
    //         first_item.province_list != undefined &&
    //         first_item.province_list.length > 0
    //       ) {
    //         let second_children = [];
    //         first_item.province_list.forEach((second_item) => {
    //           let second_obj = {
    //             value: second_item.id,
    //             label: second_item.name,
    //           };
    //           second_children.push(second_obj);
    //           first_obj.children = second_children;

    //           //   二级目录的children
    //           if (
    //             second_item.city_list != undefined &&
    //             second_item.city_list.length > 0
    //           ) {
    //             let third_children = [];
    //             second_item.city_list.forEach((third_item) => {
    //               let third_obj = {
    //                 value: third_item.id,
    //                 label: third_item.name,
    //               };
    //               third_children.push(third_obj);
    //               second_obj.children = third_children;
    //               //   console.log(third_obj)
    //             });
    //           }
    //         });
    //       }
    //       country_array.push(first_obj);
    //     });
    //     this.country_options = country_array;
    //   } else {
    //     this.country_options = "";
    //   }
    // },
    // 保存信息
    save_model_info() {
      this.loading = false;
      let _me = this;
      let params = {
        id: this.$route.query.id,
        area_score_weight: _me.pre_model_item.area_score_weight,
        turnover_score_weight: _me.pre_model_item.turnover_score_weight,
        smok_turnover_score_weight:
          _me.pre_model_item.smok_turnover_score_weight,
        extra_shop_mall_score: _me.pre_model_item.extra_shop_mall_score,
        extra_golden_business_zone_score:
          _me.pre_model_item.extra_golden_business_zone_score,
      };
      let score_weight =
        params.area_score_weight +
        params.turnover_score_weight +
        params.smok_turnover_score_weight;
      if (score_weight == 1) {
        _me.$common
          .httpPost("/api/grade/admin/update/one", params)
          .then((res) => {
            if (res.code == 1000000) {
              _me.$message.success("更新了一个评分标准");
              this.$router.go(-1);
            }
          })
          .catch((err) => {
            _me.loading = false;
            if (err.code == 1000009 || err.code == 1000007) {
              this.$router.push("sign-in");
            }
            if (err && err.message) {
              if (err.code == 1000009 || err.code == 1000007) {
                this.$router.push("sign-in");
              }
              _me.$message.error(err.message);
            }
          });
      } else {
        _me.$message.error("请重新选择面积权重，营业额权重，smok营业额权重");
      }
    },
    // 切换新版数据和旧版数据
    // switch_new_old(value) {
    //   console.log(value);
    //   if (value) {
    //     this.form.page_flag = 1;
    //   } else {
    //     this.form.page_flag = 2;
    //   }
    // },
    get_score_item_info(id) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: id,
      };
      this.$common
        .httpPost("/api/grade/admin/find/one", params)
        .then((res) => {
          _me.loading = false;
          if (res.code == "1000000") {
            _me.pre_model_item = res.data;
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch((err) => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err);
        });
    },
  },
  created() {},
  mounted() {
    // 获取国家地区列表
    // this.get_address();
    // 获取国家地区列表
    this.get_country_list();
    // 获取上一页表格里面一项的基本数据
    let pre_item_id = this.$route.query.id;
    if (pre_item_id) {
      this.get_score_item_info(pre_item_id);
    }
  },
};
</script>

<style scoped>
.banner-head {
  /*background-color: white;*/
  background-color: #f1f1f1;
  height: 60px;
}

.head-info {
  color: #ffffff;
}

main > form.edit_module {
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0;
  /* justify-content: center; */
  /* justify-content: space-between; */
}
main > form.edit_module > div {
  /* margin: 20px 0; */
  width: 25%;
  text-align: right;
  margin: 20px;
  /* display: flex; */
  /* justify-content: space-around; */
  /* align-items: right; */
  /* flex-direction: column; */
}
</style>
